<template>
  <v-dialog
    v-model="dialog"
    width="1250px">
    <div class="dialog-container">
      <div class="dialog-header">
        <h2>Add Related Ticket</h2>
        <div class="btn-container">
          <v-button
            size="small"
            @click="dialog = false">Cancel
          </v-button>
          <v-button
            size="small"
            type="primary"
            @click="onAttach">Attach
          </v-button>
        </div>
      </div>
      <div class="dialog-body">
        <div
          class="flex filter-flex">
          <div class="form-item">
            <span>Search</span>
            <v-input
              v-model="search"
              placeholder="ID, Customer Name, Customer Contact, CS Name"
              @keyEnter="filterData"/>
          </div>
          <div class="form-item">
            <span>Refer Date</span>
            <v-date-picker
              v-model="refer_date"
              :clearable="true"
              type="daterange"
              @change="filterData"/>
          </div>
        </div>
        <div class="form-item">
          <span>Filter by Type</span>
          <v-radio-group
            v-model="type"
            :list="ticketSelectOptions"
            @change="filterData"/>
        </div>
        <!-- <div class="filter-container">
          <span>Filter by Type</span>
          <div class="filter-checkbox">
            <v-checkbox-group
              v-model="type"
              :borderBlock="true"
              :list="ticketTypeOptions"
              @change="filterData" />
          </div>
        </div> -->
        <div class="transparent">
          <el-table
            ref="table"
            :data="tableData"
            :header-row-class-name="'tableHeader'"
            style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              width="55"
              align="center"
              :selectable="selectable"
            >
            </el-table-column>
            <el-table-column
              prop="id"
              label="ID"></el-table-column>
            <el-table-column
              prop="subject"
              label="Subject"></el-table-column>
            <el-table-column
              prop="requester"
              label="Requester"></el-table-column>
            <el-table-column
              prop="created_at"
              label="Created On"></el-table-column>
            <el-table-column
              label="Type">
              <template #default="{ row }">
                <span class="span-checkbox">{{ row.type_language }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="assignee"
              label="Assigned To"></el-table-column>
          </el-table>
          <v-pagination
            :total="pageConfig.total"
            :current="pageConfig.currentPage"
            @currentChange="currentChange"/>
        </div>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import MixinOptions from '@/mixins/options'
import {addRelatedTicket, getAllTicketList} from '@/api/ticket'
import {bindEnquiryTicket} from '@/api/enquiry'

export default {
  name: 'RelatedTickets',
  mixins: [MixinOptions],
  props: {
    ticketId: {
      type: [String, Number],
      default: ''
    },
    referTickList: {
      type: Array,
      default: () => ([])
    },
    isEnquiry: {
      type: Boolean,
      default: false
    },
    isFina: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      dialog: false,
      search: '',
      refer_date: [],
      type: '',
      tableData: [{id: 0}, {id: 1}, {id: 2}],
      selectionList: []
    }
  },
  computed:{
    ticketSelectOptions(){
      let arr = this.ticketListOptions
      arr.unshift({name:'All',id:''})
      return arr
    }
  },
  watch: {
    dialog: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.network().getAllTicketList()
          this.getRelatedData()
        }
      }
    }
  },
  methods: {
    changeDialog() {
      this.dialog = !this.dialog
    },
    rowClick(row) {
      this.$refs.table.toggleRowSelection(row)
    },
    selectable(row,index){
      if(this.ticketId == row.id)
        return  false
      else return  true
    },
    handleSelectionChange(val) {
      this.selectionList = val.reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
    },
    getRelatedData() {
      if (this.referTickList)
        this.referTickList.forEach(item => {
          this.tableData.forEach(table => {
            if (item.id == table.id)
              this.$nextTick(() => {
                this.$refs.table.toggleRowSelection(table, true)
              })
            this.selectionList.push(item.id)
          })
        })
      if(this.ticketId){
        this.tableData.forEach(table => {
          if (this.ticketId == table.id)
            this.$nextTick(() => {
              this.$refs.table.toggleRowSelection(table, true)
            })
          this.selectionList.push(this.ticketId)
        })
      }
    },
    onAttach() {
      //
      if(this.isEnquiry)
        this.network().bindEnquiryTicket()
      else
        this.network().addRelatedTicket()
    },
    filterData() {
      this.pageConfig.currentPage = 1
      this.network().getAllTicketList()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getAllTicketList()
    },
    network() {
      return {
        getAllTicketList: async () => {
          const {data} = await getAllTicketList({
            type: this.type,
            page: this.pageConfig.currentPage,
            search: this.search,
            refer_date: this.refer_date,
            merchant_platform:this.isFina?2:1
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
          if (this.dialog)
            this.getRelatedData()
        },
        addRelatedTicket: async () => {
          const {data} = await addRelatedTicket({
            ticket_id: this.ticketId,
            relation_ticket_id: this.selectionList
          })
          this.$emit('success')
          this.dialog = false
        },
        bindEnquiryTicket: async () => {
          const {data} = await bindEnquiryTicket({
            enquiry_id: this.ticketId,
            relation_ticket_id: this.selectionList
          })
          this.$emit('success')
          this.dialog = false
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
  padding: 15px;
  color: #616266;

  .dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 -15px;
    padding: 0 15px 5px 15px;
    //   border-bottom: 1px solid #dddfe7;
    h1 {
      font-size: 24px;
    }
  }

  .dialog-body {
    .filter-flex {
      margin-top: 10px;

      .form-item:first-child {
        margin-right: 15px;
        width: 400px;
      }

      .form-item:last-child {
        width: 400px;
      }
    }

    .filter-container {
      display: flex;
      align-items: center;
      margin: 10px auto 20px 0;

      & > span:first-child {
        font-size: 12px;
        font-weight: bold;
      }

      .filter-checkbox {
        margin: 0 20px;
      }

      .input-container {
        width: 360px;
      }
    }
  }
  ::v-deep .el-table{
    border-radius: 4px;
    border: 1px solid #E1E4E8;
    tr{
      td{
        //display: flex;
        padding: 10px 15px 10px 0!important;
        vertical-align: top;
        margin-right: 15px;
        //height: 40px;
        &.el-table-column--selection{
          padding-left: 10px!important;
        }
        .cell{
          //min-height: 40px;
          line-height: 23px;
          position: relative;
          height: inherit;
          //margin-left: 10px;
          //margin-right: 10px;
          padding: 0;
          //padding: 5px 10px;
          //position: absolute;
          //top: 10px;
        }
      }
    }

  }
  ::v-deep .tableHeader {
    margin-top: 30px;
    background: #F6F8FA !important;
    border-bottom: 1px solid #E1E4E8;
    th {
      background-color: #F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      /* Text/text-gray-dark */
      padding: 10px 0!important;
      color: #24292E!important;
      .cell{
        padding-left: 0;
      }
      &.el-table-column--selection{
        padding-left: 10px!important;
      }
    }
    .button-border{
      display: inline-block;
      padding: 0px 10px;
      height: auto;
      //line-height: 30px;
      font-size: 12px;
      border-radius: 50px;
      border: 1px solid #E1E4E8;
      color: #24292E;
      background: white;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 18px;

    }
  }

}

</style>
